import { Alert, Snackbar } from "@mui/material";
import React, { useState } from "react";

interface ToastContextProps {
  show: (
    message: string,
    type?: "success" | "error" | "info" | "warning"
  ) => void;
}

const toastContextDefault: ToastContextProps = {
  show: () => {},
};

export const ToastStateContext =
  React.createContext<ToastContextProps>(toastContextDefault);

const ToastContextFC: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState("");
  const [type, setType] = useState<"success" | "error" | "info" | "warning">(
    "success"
  );

  function show(
    message: string,
    type?: "success" | "error" | "info" | "warning"
  ) {
    setMessage(message);
    setType(type || "success");
    setVisible(true);
  }

  function handleClose() {
    setVisible(false);
  }

  return (
    <ToastStateContext.Provider value={{ show }}>
      {children}
      <Snackbar
        open={visible}
        autoHideDuration={1500}
        onClose={handleClose}
        anchorOrigin={{
          horizontal: "right",
          vertical: "bottom",
        }}
      >
        <Alert
          onClose={handleClose}
          severity={type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </ToastStateContext.Provider>
  );
};

export const useToast = () => React.useContext(ToastStateContext);

export default ToastContextFC;
